<header class="hide-for-print hero-header pdf-page-wrapper">
  <div class="hero-header__content">
    <a class="hero-header__logo-link" routerLink="/">
      <img [src]="logoUrl" [alt]="getSiteName()" class="hero-header__logo">
    </a>

    @if (!isPrintPDFRoute) {
      <h1 class="primary-heading primary-heading--hero-header">
        <span [innerText]="'Hello' | translate"></span>
        @if (getFirstName()) {
          <span [innerText]="' ' + getFirstName()"></span>
        }
      </h1>
      <h2 class="secondary-heading secondary-heading--hero-header" [innerText]="'At SOLV Energy your career is worth more than a paycheck.' | translate"></h2>
      <p [innerText]="'Your Total Rewards Statement shows how much the company pays on your behalf. Use the tools below to understand the value of your annual benefits and cash compensation.' | translate"></p>
    }

    <!-- Start: PDF print only -->
    @if (isPrintPDFRoute) {
      <h1 class="primary-heading">
        <span class="primary-heading__first-name">
          @if (getFirstName()) {
            <span [innerText]="getFirstName()"></span>'s
          }
        </span>
        <span class="primary-heading__title" [innerText]="'SOLV Energy' | translate"></span>
      </h1>
    }
    <!-- End: PDF print only -->

    <core-toggle-figures></core-toggle-figures>

  </div>
  <div class="hero-header__gfx">
    <img class="hero-header__photo" [src]="imageUrl" [alt]="imageAlt">
  </div>

  <a href="#" class="btn btn--logout btn--logout-hero" [routerLink]="'/logout'" [innerText]="'Logout' | translate"></a>
</header>

<!-- Standard web page print styles-->
<div class="print-only">
  <a class="hero-header__logo-link" routerLink="/">
    <img [src]="logoInvertedUrl" [alt]="getSiteName()" class="hero-header__logo">
  </a>
</div>
